"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const options_1 = __importDefault(require("./options"));
class SchemaForm {
    constructor(schema) {
        this.schema = schema;
    }
    static create(schema) {
        return new SchemaForm(schema).getSchema();
    }
    getSchema() {
        const fields = {};
        Object.entries(this.schema).forEach(([key, options]) => {
            fields[key] = options_1.default.getOptions(options);
        });
        return fields;
    }
}
exports.default = SchemaForm;
